import { RootState } from 'redux/reducers/rootReducer';

const assignmentCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentCreatedAt;
const assignmentDraftCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentDraftCreatedAt;
const jobTitlesSelector = (state: RootState) => state.assignment.jobTitles;
const isJobTitlesLoadingSelector = (state: RootState) =>
  state.assignment.isJobTitlesLoading;
const assignmentDetailsSelector = (state: RootState) =>
  state.assignment.assignmentDetails;
const isTemplateAssignmentModalOpenSelector = (state: RootState) =>
  state.assignment.isTemplateAssignmentModalOpen;
const assignmentTemplateCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentTemplateCreatedAt;
const assignmentDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.assignment.assignmentDetailsUpdatedAtByAdmin;

export {
  jobTitlesSelector,
  assignmentDetailsSelector,
  assignmentCreatedAtSelector,
  assignmentDraftCreatedAtSelector,
  isJobTitlesLoadingSelector,
  isTemplateAssignmentModalOpenSelector,
  assignmentTemplateCreatedAtSelector,
  assignmentDetailsUpdatedAtByAdminSelector,
};
